// extracted by mini-css-extract-plugin
export default {"makeDefaultButton":"AddressListItem_makeDefaultButton__fD3xO","badge":"AddressListItem_badge__5leXX"};